import { atomWithReset } from "jotai/utils";

import type {
  FirstScheduleForm,
  SelectedLocation,
} from "@/lib/form-schemas/first-schedule-schema";

const firstScheduleAtom = atomWithReset<FirstScheduleForm>({
  selectedLocation: null,
  locationTimes: [],
  codAgendas: [],
  firstAppointment: null,
  followUp: null,
});

type FirstScheduleHistoryStop = "origin" | "intro" | "firstAppointment" | "followUp";

const firstScheduleHistoryAtom = atomWithReset<
  Partial<Record<FirstScheduleHistoryStop, number>>
>({});

const hasLocationTimes = (form: FirstScheduleForm): boolean =>
  form.locationTimes.some((lt) => lt.times.length > 0);

export type { FirstScheduleForm, FirstScheduleHistoryStop, SelectedLocation };
export { firstScheduleAtom, firstScheduleHistoryAtom, hasLocationTimes };
